import { forEach, get, set, startsWith } from 'lodash';

class Model {
  constructor(data) {
    this._data = data;
  }

  /**
   * This function maps all getters on the model to a simple key-value pair
   */
  toJSON = () => {
    const result = {};

    const instance = this;
    const prototype = Object.getPrototypeOf(instance);
    const propertyNames = Object.getOwnPropertyNames(prototype);

    forEach(propertyNames, propertyName => {
      const descriptor = Object.getOwnPropertyDescriptor(prototype, propertyName);

      // If property is valid getter, set its value on our result object
      if (descriptor.get && !startsWith(propertyName, '_')) {
        const value = get(instance, [propertyName]);

        set(result, [propertyName], value);
      }
    });

    return result;
  };

  /**
   * Turns instance into plain JS object. This is used for validating schemas
   */
  toPlainObject = () => {
    const stringifiedObject = JSON.stringify(this);

    return JSON.parse(stringifiedObject);
  };
}

export default Model;
